/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Address/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Address({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/Emails/Content/Email/Edit/Content/Address",
  isInvalid,
  onChange
  
}) {
let contactMethodAssociationEmailAddressValueData = fromData.useDataValue({ viewPath,
context: 'contact_method_association',
path: 'email.address',
})
let contactMethodAssociationEmailAddressIsValidData = fromData.useDataIsValid({ viewPath,
context: 'contact_method_association',
path: 'email.address',
validate: fromValidate.email,
required: true,
})
let contactMethodAssociationEmailAddressChangeData = fromData.useDataChange({ viewPath,
context: 'contact_method_association',
path: 'email.address',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 data="contact_method_association.email.address"
 validate="/Data/validate.js email"
 invalid={!contactMethodAssociationEmailAddressIsValidData}
 required={true}
 value={contactMethodAssociationEmailAddressValueData}
 onChange={contactMethodAssociationEmailAddressChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Email Address"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="email"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}